import './index.scss';

import React, { useState } from 'react';

import { MODAL_TYPE } from '@/src/components/common/Elements/Modal/Config';
import ModalPopup from '@/src/components/common/Elements/Modal/ModalPopup/ModalPopup';

import DocumentList from './DocumentList';

const DocumentLibraryModal = (props) => {
  const [documentList, setDocumentList] = useState([]);
  const { onClose, onUpload, title } = props;

  const handleUpload = () => {
    onUpload(documentList);
  };
  const isValid = documentList.length > 0;

  return (
    <ModalPopup
      className={'select-file-modal'}
      id={'library-modal'}
      title={title}
      modalType={MODAL_TYPE.inverse}
      modalWidth={'tw-w-[628px]'}
      onClose={onClose}
      onConfirm={handleUpload}
      confirmBtn={{ label: 'Upload', disabled: !isValid }}
    >
      <DocumentList setSourceDocumentList={setDocumentList} />
    </ModalPopup>
  );
};

export default DocumentLibraryModal;
